import { render, staticRenderFns } from "./ModalNovoVereador.vue?vue&type=template&id=2e7c7e07"
import script from "./ModalNovoVereador.vue?vue&type=script&lang=js"
export * from "./ModalNovoVereador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports